// lib/games.mjs のブラウザ代替。ゲームは物理コピーされず、VFS 上の「仮想ゲームディレクトリ」
// (/vfs/newgames/<gameId>) として backend が op ごとにハイドレートする。
// listGames は uniqueGameId の衝突回避に必要なため、backend が IDB から集めた登録簿を注入する。
import path from './path.mjs';
import { gameDirOf } from './repo-paths.mjs';
import { vfs } from '../vfs.mjs';

export const META_FILE = '.newgame-meta.json';

let registry = []; // [{gameId, ...}]
export function __setGameRegistry(list) {
    registry = Array.isArray(list) ? list : [];
}

function readJsonIfExists(p) {
    try {
        return JSON.parse(vfs.read(p));
    } catch {
        return null;
    }
}
function writeJson(p, v) {
    vfs.write(p, JSON.stringify(v, null, 2) + '\n');
}

export function listGames() {
    return registry.map((g) => ({ ...g }));
}

export function requireGameDir(gameId) {
    const dir = gameDirOf(gameId);
    if (!vfs.exists(path.join(dir, 'package.json'))) {
        throw new Error(`ゲームが見つかりません: newgames/${gameId}/（先に「② ゲーム生成」を実行してください）`);
    }
    return dir;
}

export function readGameMeta(gameId) {
    return readJsonIfExists(path.join(gameDirOf(gameId), META_FILE)) ?? {};
}

export function updateGameMeta(gameId, updater) {
    const mp = path.join(gameDirOf(gameId), META_FILE);
    const meta = readJsonIfExists(mp) ?? {};
    const next = updater(meta) ?? meta;
    writeJson(mp, next);
    return next;
}

export function deleteGame() {
    throw new Error('ブラウザ完結版ではゲーム削除は物語プロジェクトの削除に統合されています。');
}
